import {useEffect} from "react";

const PointerLock = ({elem, lockPointer = false}) => {

  const requestPointerLockFunc = () => {
    if (document.pointerLockElement) {
      return true
    }
    const comp = elem.current;
    if (comp && comp.requestPointerLock) {
      comp.requestPointerLock()?.then(() => {
        // pointer lock success now request for unadjusted movement
        comp.removeEventListener("click", requestPointerLockFunc)
        comp.removeEventListener("mousemove", requestPointerLockFunc)
        comp.removeEventListener("keydown", requestPointerLockFunc)

        comp.requestPointerLock({unadjustedMovement: true}).catch(e => {
          console.error("Failed to request unadjusted movement", e);
        })
      }).catch((e) => {
        console.error("Failed to lock pointer", e);
      })
    }
    return true
  }

  useEffect(() => {
    if (elem.current && lockPointer) {
      const comp = elem.current;
      comp.addEventListener("click", requestPointerLockFunc)
      comp.addEventListener("mousemove", requestPointerLockFunc)
      comp.addEventListener("keydown", requestPointerLockFunc)
      requestPointerLockFunc()
        return () => {
        releasePointerLock()
        comp.removeEventListener("click", requestPointerLockFunc)
        comp.removeEventListener("mousemove", requestPointerLockFunc)
        comp.removeEventListener("keydown", requestPointerLockFunc)
      }

    }
  }, [elem, lockPointer])

  const releasePointerLock = () => {
    if (document.pointerLockElement) {
      document.exitPointerLock()
    }
  }

  return null
}

export default PointerLock